import { useKeycloak } from "@react-keycloak/web";
import React, { useEffect, useState } from "react";
import { useFetchCompteGetAllMarquesQuery } from "../../../redux/slice/api/FO/compteApi";
import { IMarque } from "../../../models/interfaces/IMarques";
import CpntDataTable from "../../../components/dataTable/CpntDataTable";
import { ILocation } from "../../../models/interfaces/ILocation";
import { ITitle } from "../../../models/interfaces/ITitle";
import SpinnerEditeurPro from "../../FO/components/SpinnerEditeurPro";


interface IProps {
  IdCompte: number;
  refetch: boolean;
}


const FOCompteSocieteTabFond: React.FC<IProps> = ({ IdCompte,refetch }) => {

  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
 const [fetchFond, setFetchFond] = useState(refetch);
 
  //Marques 
  const { data: CompteMarquesResult, isFetching: CompteMarquesisFetching, error: CompteMarqueserror } = useFetchCompteGetAllMarquesQuery(IdCompte, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || IdCompte === 0 || fetchFond ===false,
  });
    useEffect(() => {
      setFetchFond(refetch);
    }, [refetch])

  
  const actions: ILocation[] = [
    // {
    //   PathsName: { CompteSociete: "/admin/comptesociete/[[IdSociete]]"},
    //   State: { type_access: "" },
    //   ClassName: "bi-receipt Action-button",
    // },
  ];

  const dataHeaderName: ITitle[] = [
    // {
    //   Id: "Id",
    //   Name: "Id",
    //   Class: "",
    //   sorter: (a: IMarque, b: IMarque) =>
    //     a.Id - b?.Id,
    // },
    {
      Id: "IdExterne",
      Name: "Id Marque",
      Class: "",
      sorter: (a: IMarque, b: IMarque) =>
        a.IdExterne - b?.IdExterne,
    },
    {
      Id: "Libelle",
      Name: "Libelle",
      Class: "",
      sorter: (a: IMarque, b: IMarque) =>
        a?.Libelle?.localeCompare(b?.Libelle),
    },
    {
      Id: "Source",
      Name: "Source",
      Class: "",
      sorter: (a: IMarque, b: IMarque) =>
        a?.Source?.localeCompare(b?.Source),
    },
  ];


  const dataItemsStyle = {
    // Id: "",
    IdExterne:"",
    Libelle: "",
    Source: ""
  };

 
 
  return (
    <>
     {CompteMarquesisFetching ? (
      <SpinnerEditeurPro />
          ) : CompteMarqueserror ? (
            <div>Error</div>
          ) : (
            CompteMarquesResult?.Marques && //&& numberOfResults !== null && numberOfResults > 0 &&
              <>
              {/* <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination> */}
              <div style={{display: 'flex', justifyContent: 'flex-end'}}>
              <div className="col-1.5" style={{margin:"5px"}}>
                Nombre total de marque(s): <b>{CompteMarquesResult?.Marques?.length}</b>
              </div> 
              </div>
              <div className="card p-0 mb-2">
                <div className="table-responsive">
                  <CpntDataTable
                    data={CompteMarquesResult && CompteMarquesResult?.Marques ? [...CompteMarquesResult.Marques] : []}
                    dataHeader={dataHeaderName}
                    dataItemsStyle={dataItemsStyle}
                    actions={actions}
                    actualFilterPage="PagFOComptesCompte"
                    // updateSorter={setSortField}
                    // updateDescending={setIsDescending}
                />
                </div>
              </div>
              {/* <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination> */}

              </>
          )}
      </>
  )
    
}; 

export default FOCompteSocieteTabFond;

